import React, { Component } from "react";

class ReporteFormato2 extends Component {
  render() {
    return (
      <div>
        <fieldset className="col-md-12">
          <legend>EXPORTACIONES</legend>

          <div className="table-responsive">
            <table className="table table-striped m-b-0 table-hover">
              <colgroup>
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
                <col style={{ width: "6.25%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Nombre Genérico</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Producto</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Presentación</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>País Despacho</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Unidades Entrada</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Gramos Entrada</b>
                  </th>

                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Unidades Egreso Exportado</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Gramos Egreso Exportado</b>
                  </th>

                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Unidades Ingreso Devolución</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Gramos Ingreso Devolución</b>
                  </th>

                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Unidades Egreso Deterioro</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Gramos Egreso Deterioro</b>
                  </th>

                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Unidades Egreso Ventas</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Gramos Egreso Ventas</b>
                  </th>

                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Unidades Existencia Actual</b>
                  </th>
                  <th
                    colSpan="1"
                    rowSpan="3"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>Gramos Existencia Actual</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.props.state.option_productos.map((producto, index) => (
                  <tr key={index}>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.nombre_generico}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.producto_concat}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.presentacion}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.pais_despacho}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.cantidad_entrada}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {!producto.pedir_gramos_entrada ? (
                        producto.gramos_entrada
                      ) : (
                        <div className="form-group">
                          <input
                            type="text"
                            maxLength="15"
                            autoComplete="off"
                            className="form-control"
                            value={producto.gramos_entrada || ""}
                            id={`gramos_entrada-${index}`}
                            onChange={this.props.handleCantidadGramosChange}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id={`gramos_entrada-${index}-error`}
                          ></div>
                        </div>
                      )}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.cantidad_exportado}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {!producto.pedir_gramos_exportado ? (
                        producto.gramos_exportado
                      ) : (
                        <div className="form-group">
                          <input
                            type="text"
                            maxLength="15"
                            autoComplete="off"
                            className="form-control"
                            value={producto.gramos_exportado || ""}
                            id={`gramos_exportado-${index}`}
                            onChange={this.props.handleCantidadGramosChange}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id={`gramos_exportado-${index}-error`}
                          ></div>
                        </div>
                      )}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.cantidad_devolucion}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {!producto.pedir_gramos_devolucion ? (
                        producto.gramos_devolucion
                      ) : (
                        <div className="form-group">
                          <input
                            type="text"
                            maxLength="15"
                            autoComplete="off"
                            className="form-control"
                            value={producto.gramos_devolucion || ""}
                            id={`gramos_devolucion-${index}`}
                            onChange={this.props.handleCantidadGramosChange}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id={`gramos_devolucion-${index}-error`}
                          ></div>
                        </div>
                      )}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.cantidad_deterioro}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {!producto.pedir_gramos_deterioro ? (
                        producto.gramos_deterioro
                      ) : (
                        <div className="form-group">
                          <input
                            type="text"
                            maxLength="15"
                            autoComplete="off"
                            className="form-control"
                            value={producto.gramos_deterioro || ""}
                            id={`gramos_deterioro-${index}`}
                            onChange={this.props.handleCantidadGramosChange}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id={`gramos_deterioro-${index}-error`}
                          ></div>
                        </div>
                      )}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.cantidad_ventas}
                    </td>
                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {!producto.pedir_gramos_ventas ? (
                        producto.gramos_ventas
                      ) : (
                        <div className="form-group">
                          <input
                            type="text"
                            maxLength="15"
                            autoComplete="off"
                            className="form-control"
                            value={producto.gramos_ventas || ""}
                            id={`gramos_ventas-${index}`}
                            onChange={this.props.handleCantidadGramosChange}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id={`gramos_ventas-${index}-error`}
                          ></div>
                        </div>
                      )}
                    </td>

                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {producto.cantidad_existencia_actual}
                    </td>

                    <td
                      colSpan="1"
                      className="text-center"
                      style={{ verticalAlign: "middle" }}
                    >
                      {!producto.pedir_gramos_existencia_actual ? (
                        producto.gramos_existencia_actual
                      ) : (
                        <div className="form-group">
                          <input
                            type="text"
                            maxLength="15"
                            autoComplete="off"
                            className="form-control"
                            value={producto.gramos_existencia_actual || ""}
                            id={`gramos_existencia_actual-${index}`}
                            onChange={this.props.handleCantidadGramosChange}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id={`gramos_existencia_actual-${index}-error`}
                          ></div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </fieldset>
      </div>
    );
  }
}

export default ReporteFormato2;
